import React from "react";
import {
  Button,
  Form,
  TextInput,
  PasswordInput,
} from "carbon-components-react";
import { ArrowRight24, CheckboxChecked32 } from "@carbon/icons-react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import http from "../../http-common";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Card from "../../components/Card/Card";
import UserForm from "./UserForm";

const requiredMessage = "Campo obrigatório";
const invalidNuit = "NUIT inválido";

const userSchema = yup.object({
  firstName: yup.string().required(requiredMessage),
  lastName: yup.string().required(requiredMessage),
  username: yup
    .string()
    .required(requiredMessage)
    .length(9, invalidNuit)
    .matches(/^[0-9]*$/, invalidNuit),
  email: yup.string().required(requiredMessage).email("Email inválido"),
  password: yup.string().required(requiredMessage),
});

const SignupPage = () => {
  return (
    <div className="bx--row">
      <div className="bx--col-lg-6 content">
        <h1 className="title">Critérios de Elegibilidade</h1>
        <ul className="eligibility-list">
          <li>
            Os/as candidatos/as devem ter 18 ou mais anos de idade no momento de
            candidatura
          </li>
          <li>Os/as candidatos/as devem ser de nacionalidade moçambicana</li>
          <li>
            Os/as candidatos/as devem ter atingido no mínimo a 7ª classe (nível
            primário)
          </li>
          <li>
            Os/as candidatos/as devem possuir um negócio próprio para concorrer.
          </li>
          <li>
            Os/as candidatos/as devem ter residência nos distritos alvo nas
            seguintes províncias: Cabo Delgado, Nampula, Tete
          </li>
        </ul>
      </div>
      <div className="bx--col-sm-12 bx--col-lg-6">
        <Card title="Regista-te">
          <UserForm
            mode={"SIGNUP"}
            url={"/auth/signup"}
            successMessage="Conta Criada com sucesso"
            onSuccessNavigateTo={"/"}
          />
        </Card>
      </div>
    </div>
  );
};

export default SignupPage;
